import { createStore } from 'satcheljs';
var defaultFocusedInboxRollupStore = {
    uniqueSenders: null,
    unseenCountToDisplay: null,
    viewType: 0 /* Invalid */,
};
var store = createStore('focusedInboxRollupStore', defaultFocusedInboxRollupStore)();
export default store;
//# sourceMappingURL=store.js.map